import AxiosClient from '../../../../functional/Axios/AxiosClient';

export const rightsManagerApi = {
  rightsGet: (id) => AxiosClient.get(`/root/users/${id}/role/rights`),
  rightsUpdate: (data) => AxiosClient.post(`/root/users/${data.id}/role/rights`, { ...data }),
  checkUserRights: () => AxiosClient.get('/root/'),
};
